import type {
  DefaultNodeTypes,
  SerializedLinkNode,
} from '@payloadcms/richtext-lexical'
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'
import {
  type JSXConvertersFunction,
  LinkJSXConverter,
  RichText as RichTextWithoutBlocks,
} from '@payloadcms/richtext-lexical/react'

import { cn } from '@/utilities/ui'
import { Media } from '@/theme/components/Media/Media'
import type { Media as MediaType } from '@/payload-types'

type NodeTypes = DefaultNodeTypes

const internalDocToHref = ({ linkNode }: { linkNode: SerializedLinkNode }) => {
  const { value, relationTo } = linkNode.fields.doc!
  if (typeof value !== 'object') {
    throw new Error('Expected value to be an object')
  }
  const slug = value.slug
  return relationTo === 'pages' && slug !== 'home' ? `/${slug}` : '/'
}

const jsxConverters: JSXConvertersFunction<NodeTypes> = ({ defaultConverters }) => ({
  ...defaultConverters,
  ...LinkJSXConverter({ internalDocToHref }),
  upload: ({ node }) => {
    if (!node?.value) return null

    return (
      <div className="w-full flex justify-center my-7">
        <Media
          resource={node.value as MediaType}
          className="max-w-full h-auto mx-auto"
          imgClassName="w-full rounded-sm"
        />
      </div>
    )
  },
})

type Props = {
  data: SerializedEditorState
  enableProse?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export default function RichText(props: Props) {
  const { className, enableProse = true, ...rest } = props
  return (
    <RichTextWithoutBlocks
      converters={jsxConverters}
      className={cn({ 'prose prose-atelier max-w-none': enableProse }, className)}
      {...rest}
    />
  )
}
